import React, { useCallback } from 'react';

import { styled } from '../theme';
import { Size, Status, matchSize } from '../utility/common-props-helpers';
import SvgIcon from './SvgIcon';

type Props = {
    size?: Size;
    type?: string;
    status?: Status;
    name?: string;
    value: string;
    onChange?: (ev: any) => void;
};

const getHeight = matchSize({
    medium: 40,
    large: 50,
});

const StatusIcon = styled(SvgIcon)<Props>(({ theme, status = 'success', size }) => ({
    position: 'absolute',
    top: (getHeight(size) - 15) / 2,
    right: 3,
    color: theme.color[status],
}));

const ERROR = 'error';

const InputStatus = ({ status, size, type, name, onChange, value }: Props) => {
    const resetInputValue = useCallback(() => {
        const resetValueEvent = {
            target: {
                type,
                name,
                value: '',
            },
        };
        onChange && onChange(resetValueEvent);
    }, [type, name, onChange]);

    const handleClickStatus = useCallback(() => {
        switch (status) {
            case ERROR:
                resetInputValue();
                break;
        }
    }, [status, resetInputValue]);

    if (status === ERROR && !value) return null;

    return (
        <StatusIcon
            size={size}
            status={status}
            src={`/icons/ic-status-${status}.svg`}
            onClick={handleClickStatus}
        />
    );
};

export default InputStatus;
